import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62db59d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["d"]
const _hoisted_3 = ["d"]
const _hoisted_4 = ["d"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<defs data-v-62db59d8><linearGradient id=\"partners-icon-top-gradient\" x1=\"7.38329\" y1=\"22.4168\" x2=\"7.38329\" y2=\"-0.0395872\" gradientUnits=\"userSpaceOnUse\" data-v-62db59d8><stop offset=\"0.14\" stop-color=\"#0095D6\" data-v-62db59d8></stop><stop offset=\"0.56\" stop-color=\"#00C6C1\" data-v-62db59d8></stop><stop offset=\"1\" stop-color=\"#A1E2B7\" data-v-62db59d8></stop></linearGradient><linearGradient id=\"partners-icon-bottom-gradient\" x1=\"7.72946\" y1=\"11.4164\" x2=\"7.72946\" y2=\"-11.04\" gradientUnits=\"userSpaceOnUse\" data-v-62db59d8><stop offset=\"0.09\" stop-color=\"#0095D6\" data-v-62db59d8></stop><stop offset=\"0.46\" stop-color=\"#00C6C1\" data-v-62db59d8></stop><stop offset=\"0.83\" stop-color=\"#A1E2B7\" data-v-62db59d8></stop></linearGradient></defs>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "login-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    (!_ctx.isLogin)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: "partners-icon",
          xmlns: "http://www.w3.org/2000/svg",
          width: _ctx.size.width,
          height: _ctx.size.height,
          viewBox: `0 0 ${_ctx.size.width} ${_ctx.size.height}`
        }, [
          _createElementVNode("path", { d: _ctx.path }, null, 8, _hoisted_2),
          _createElementVNode("path", {
            d: _ctx.partnersIconTopPath,
            class: "partners-icon-top"
          }, null, 8, _hoisted_3),
          _createElementVNode("path", {
            d: _ctx.partnersIconBottomPath,
            class: "partners-icon-bottom"
          }, null, 8, _hoisted_4),
          _hoisted_5
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.loginButtonText), 1)
  ]))
}